// Form validation rules shared by the report and claim forms.
// Each function takes the i18n `t` and returns a localized error message, or null when valid.

export function validateReport(form, hasPhoto, t) {
  if (!hasPhoto) return t("validation.needPhoto");
  if (!form.age_range) return t("validation.needAge");
  if (form.name_unknown) {
    if (!(form.clothing || form.distinguishing_marks || form.eye_color || form.skin_color)) {
      return t("validation.needCharacteristic");
    }
  } else if (!form.first_name) {
    return t("validation.missing", { field: t("validation.fFirstName") });
  }
  const required = [
    ["shelter_name", "fShelter"],
    ["found_location", "fFoundLocation"],
    ["state", "fState"],
    ["municipality", "fMunicipality"],
    ["reporter_type", "fWhoReports"],
    ["reporter_phone", "fPhone"],
  ];
  for (const [key, fieldKey] of required) {
    if (!form[key]) return t("validation.missing", { field: t(`validation.${fieldKey}`) });
  }
  return null;
}

export function validateClaim(form, nameUnknown, t) {
  const base = [
    ["claimant_name", "fYourName"],
    ["cedula", "fCedula"],
    ["relationship", "fRelationship"],
    ["claimant_phone", "fPhone"],
  ];
  for (const [key, fieldKey] of base) {
    if (!form[key]) return t("validation.missing", { field: t(`validation.${fieldKey}`) });
  }
  if (nameUnknown) {
    const extra = [
      ["clothing_description", "fClothingWorn"],
      ["lost_contact_date", "fLostDate"],
      ["lost_contact_place", "fLostPlace"],
    ];
    for (const [key, fieldKey] of extra) {
      if (!form[key]) return t("validation.missing", { field: t(`validation.${fieldKey}`) });
    }
  }
  return null;
}
